import { Chip } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledNavChip = styled(Chip)(({ theme }) => ({
    '&.MuiChip-root': {
        '&:hover': {
            cursor: 'pointer',
            opacity: 0.4
        }
    }
}));

export const InactiveChip = styled(Chip)(({ theme }) => ({
    '&.MuiChip-root': {
        color: theme.palette.error.main,
    },
    '& .MuiChip-icon': {
        color: theme.palette.error.main,
    }
}));

export const ExpiredChip = styled(Chip)(({ theme }) => ({
    '&.MuiChip-root': {
        color: theme.palette.warning.main,
    },
    '& .MuiChip-icon': {
        color: theme.palette.warning.main,
    }
}));

export const PaidChip = styled(Chip)(({ theme }) => ({
    '&.MuiChip-root': {
        color: theme.palette.success.main,
    },
    '& .MuiChip-icon': {
        color: theme.palette.success.main,
    }
}));